import { useState, useEffect } from "react";
import "./index.css";

function MultipleChoices({
  id,
  content,
  answers,
  checked,
  setChecked,
  sumChecked,
  setSumChecked,
  state,
  setState,
  scoredata,
  isResultMode, // 결과 모드인지 여부를 결정하는 prop 추가
}) {
  const [selectedItem, setSelectedItem] = useState(-1);
  const [isChecked, setIsChecked] = useState(false);
  const [scores, setScores] = useState([]);
  const keys = [0, 1, 2, 3, 4];

  useEffect(() => {
    if (isResultMode) {
      console.log("결과 모드로 진입했습니다.");
    } else {
      console.log("진단 모드로 진입했습니다.");
    }
  }, [isResultMode]); // isResultMode가 변경될 때마다 로그 출력

  useEffect(() => {
    if (scoredata.length > 0)
      scoredata.map((page) =>
        page.map((item) => {
          if (item.id === id) setScores({ ...item });
        })
      );
  }, [scoredata, id]);

  const handleSelection = (index, item) => {
    if (isResultMode || scoredata.length > 0) {
      console.log("결과 모드에서는 선택이 불가능합니다."); // 결과 모드에서 클릭 시 로그 출력
      return;
    }
    if (!isChecked) {
      setChecked(checked + 1);
      setSumChecked(sumChecked + 1);
    }
    setSelectedItem(index);
    setIsChecked(true);

    setState(
      state.map((page) =>
        page.map((question) => {
          if (id === question.id)
            return {
              ...question,
              type: item.type,
              tier: item.tier,
              priority: item.priority,
              answerId: item.id,
            };
          else return { ...question };
        })
      )
    );
    const scrollAmount = 24 * 16;
    window.scrollTo({
      top: window.pageYOffset + scrollAmount,
      behavior: "smooth",
    });
  };

  // 총 점수 계산
  const totalScore = keys.reduce(
    (accumulator, key) => accumulator + (scores[key] || 0),
    0
  );

  // answers 배열을 퍼센티지 기준으로 정렬하고 우선순위 넘버링 추가
  const sortedAnswers = [...answers].sort((a, b) => {
    const percentageA = (scores[answers.indexOf(a)] / totalScore) * 100;
    const percentageB = (scores[answers.indexOf(b)] / totalScore) * 100;

    return percentageB - percentageA; // 내림차순 정렬
  });

  // 우선순위에 따른 색상 반환 함수
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 1:
        return "var(--navy700)";
      case 2:
        return "var(--navy600)";
      case 3:
        return "var(--navy500)";
      case 4:
        return "var(--navy400)";
      default:
        return "var(--navy700)";
    }
  };

  return (
    <div className={`MultipleChoices ${isChecked}`}>
      <div className="title">{content}</div>
      <div
        className="button-container"
        style={{ height: `${4.37 * answers.length}rem` }}
      >
        {sortedAnswers.map((item, index) => {
          const priority = index + 1; // 우선순위 넘버링 (1, 2, 3, 4)
          const isSelected = selectedItem === index && !isResultMode; // 진단 모드에서 선택된 항목

          return (
            <div
              key={item.id}
              style={{ display: "flex", alignItems: "center" }}
            >
              {scoredata.length > 0 && (
                <div className="count-text">
                  {scores[answers.indexOf(item)]} / {totalScore}
                </div>
              )}
              <button
                className={`btn_answer`}
                onClick={() => handleSelection(index, item)}
                style={
                  isResultMode // 결과 모드일 때 우선순위에 따른 색상 적용
                    ? {
                        backgroundColor: getPriorityColor(priority), // 우선순위에 맞는 색상 적용
                        color: "white", // 결과 모드에서는 흰 글씨로 고정
                        opacity: `${Math.max(
                          scores[answers.indexOf(item)] / totalScore + 0.4,
                          1
                        )}`,
                      }
                    : isSelected // 진단 모드일 때 선택된 항목 스타일
                    ? {
                        backgroundColor: "var(--navy700)", // 선택된 항목
                        color: "white",
                      }
                    : {
                        // backgroundColor: "white", // 선택되지 않은 항목
                        // color: "black",
                        backgroundColor: getPriorityColor(priority), // 우선순위에 맞는 색상 적용
                        color: "white", // 결과 모드에서는 흰 글씨로 고정
                      }
                }
              >
                {item.content}
              </button>
              {scoredata.length > 0 && (
                <div className="percentage">
                  {Math.round(
                    (scores[answers.indexOf(item)] / totalScore) * 100 * 10
                  ) / 10}
                  %
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default MultipleChoices;
